import { useQuery } from "@tanstack/react-query";
import { getDashboardData, getExpiringCampaigns, getExpiringEvents, getImpactMatrixData, getLeaderBoard, getMissionControl, getReferralsData, getSnapshotData, getSubmissionStatsData, getToDo } from "../api/dashboard";

export const useGetMissionControl = () => {
    return useQuery({
        queryKey: ["mission-control"],
        queryFn: getMissionControl,
        refetchInterval: 60_000,
    });
}

export const useGetDashboardData = () => {
    return useQuery({
        queryKey: ["dashboard-data"],
        queryFn: getDashboardData,
    });
}

export const useGetSnapshotData = () => {
    return useQuery({
        queryKey: ["snapshot-data"],
        queryFn: getSnapshotData,
    })
}

export const useGetTrackImpactData = () => {
    return useQuery({
        queryKey: ["trackImpact-data"],
        queryFn: getImpactMatrixData,
    })
}

export const useGetSubmissionStatsData = () => {
    return useQuery({
        queryKey: ["submissionStats-data"],
        queryFn: getSubmissionStatsData,
    })
}

export const useGetReferralsData = () => {
    return useQuery({
        queryKey: ["referrals-data"],
        queryFn: getReferralsData,
    })
}

export const useGetLeaderBoard = () => {
    return useQuery({
        queryKey: ["leaderboard-data"],
        queryFn: getLeaderBoard,
    });
}

export const useGetToDoList = () => {
    return useQuery({
        queryKey: ["todo-data"],
        queryFn: getToDo,
    });
}

export const useGetExpiringCampaigns = () => {
    return useQuery({
        queryKey: ["expiring-campaigns"],
        queryFn: getExpiringCampaigns,
    });
}

export const useGetExpiringEvents = () => {
    return useQuery({
        queryKey: ["expiring-events"],
        queryFn: getExpiringEvents,
    });
}